import { render, staticRenderFns } from "./ReassuranceButtons.vue?vue&type=template&id=690b3528&"
import script from "./ReassuranceButtons.vue?vue&type=script&lang=js&"
export * from "./ReassuranceButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports